import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { map } from 'rxjs/operators';

import { AppUserSelectSearch } from 'src/app/core/types/app-user-select-search.type';
import { UsersService } from '../../../core/api/services/users.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'users-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class UserSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('type') type: AppUserSelectSearch = 'users';
  @Output('defaultValue') output_defaultValue = new EventEmitter<any>();

  constructor(protected currentService: UsersService) {
    super();
  }

  initConfig() {
    this.optionValue = 'userGuid';
    this.optionTitle = 'optionTitle';
    if (!this.label) this.label = 'common.user';
  }

  override getItems(): void {
    this.getItemsApi();
  }

  getItemsApi() {
    switch (this.type) {
      // users
      case 'users':
        this.optionValue = 'userGuid';
        if (this.isAllowGetItems())
          this.currentService
            .usersGetUsersList()
            .pipe(
              this.basePipeOperators(),
              map((items) => {
                return items.data.map((item) => {
                  return {
                    ...item,
                    optionTitle: `${item.userName} (${item.firstName} ${item.lastName})`,
                  };
                });
              })
            )
            .subscribe({
              next: (items) => {
                this.items = items;
                items.forEach((item, i) => {
                  let user = items.filter(
                    (user) =>
                      user.userName == item.userName && user.id != item.id
                  );
                  if (user.length > 0) {
                    items[
                      i
                    ].optionTitle = `${items[i].userName} (${items[i].firstName} ${items[i].lastName}) [${items[i].organizationName}]`;
                  }
                });
                if (this.items?.length)
                  this.output_defaultValue.emit(
                    this.items[0][this.optionValue]
                  );
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;

      // listDescendant
      case 'listDescendant':
        this.optionValue = 'id';
        if (this.isAllowGetItems())
          this.currentService
            .usersGetUsersListDescendant()
            .pipe(
              this.basePipeOperators(),
              map((items) => {
                return items.data.map((item) => {
                  return {
                    ...item,
                    optionTitle: `${item.userName} ${
                      item.firstName && item.lastName
                        ? `(${item.firstName} ${item.lastName})`
                        : ''
                    } `,
                  };
                });
              })
            )
            .subscribe({
              next: (items) => {
                this.items = items;
                items.forEach((x, i) => {
                  let user = items.filter(
                    (y) => y.userName == x.userName && y.id != x.id
                  );
                  if (user.length > 0) {
                    items[i].optionTitle = `${items[i].userName} (${
                      items[i].firstName
                    }${' '}${items[i].lastName}) [${
                      items[i].organizationName
                    }]`;
                  }
                });
                if (this.items?.length)
                  this.output_defaultValue.emit(
                    this.items[0][this.optionValue]
                  );
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;

      // currentOrganizationUsersList
      case 'currentOrganizationUsersList':
        this.optionValue = 'id';
        if (this.isAllowGetItems())
          this.currentService
            .usersGetCurrentOrganizationUsersList()
            .pipe(
              this.basePipeOperators(),
              map((items) => {
                return items.data.map((item) => {
                  return {
                    ...item,
                    optionTitle: `${item.userName}`,
                  };
                });
              })
            )
            .subscribe({
              next: (items) => {
                this.items = items;
                if (this.items?.length)
                  this.output_defaultValue.emit(
                    this.items[0][this.optionValue]
                  );
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;

      // listForAccessOrganization
      case 'listForAccessOrganization':
      // distinctUsersList
      case 'organizationUsersList':
        this.optionValue = 'userGuid';

        if (this.isAllowGetItems())
          this.currentService
            .usersGetOrganizationUsersList({ organizationId: this.id })
            .pipe(
              this.basePipeOperators(),
              map((items) => {
                return items.data.map((item) => {
                  return {
                    ...item,
                    optionTitle: `${item.userName} (${item.firstName} ${item.lastName})`,
                  };
                });
              })
            )
            .subscribe({
              next: (items) => {
                this.items = items;
                if (this.items?.length)
                  this.output_defaultValue.emit(
                    this.items[0][this.optionValue]
                  );
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;

      // listDescendant
      case 'usersListByOrganizationId':
        this.optionValue = 'id';
        if (this.isAllowGetItems())
          this.currentService
            .usersGetUsersListByOrganizationId({ organizationId: this.id })
            .pipe(
              this.basePipeOperators(),
              map((items) => {
                return items.data.map((item) => {
                  return {
                    ...item,
                    optionTitle: `${item.userName} (${item.firstName} ${item.lastName})`,
                  };
                });
              })
            )
            .subscribe({
              next: (items) => {
                this.items = items;
                if (this.items?.length)
                  this.output_defaultValue.emit(
                    this.items[0][this.optionValue]
                  );
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;
    }
  }

  //use in switch case
  isAllowGetItems(): boolean {
    if (this.initLoading) return false;
    this.isFetchData = false;
    this.initLoading = true;
    return true;
  }
}
